import React from "react";

export const DeleteContext = React.createContext();